(async function () {
  const { S, ICONS, esc, qs, img, money, shopify, shopUrl, splitDescription, getProduct, allProducts, productCard, addToCart, toast, isFav, initCarousels } = window.Store;
  const root = document.querySelector("[data-pdp]");
  const gallery = root.querySelector(".pdp-gallery");
  const dots = root.querySelector(".pdp-dots");
  const info = root.querySelector(".pdp-info");

  let product;
  try { product = await getProduct(root.dataset.handle || qs("handle") || ""); } catch (e) { console.error(e); }
  if (!product) {
    root.innerHTML = `<p class="notice">This piece could not be found — <a class="link" href="/collections/all">back to the collection</a></p>`;
    return;
  }

  document.title = `${product.title} — manej`;
  const { story, details } = splitDescription(product.descriptionHtml);
  const cat = S.categories.find((c) => c.type === product.productType);
  const hasOptions = !(product.options.length === 1 && product.options[0].values[0] === "Default Title");
  const firstAvailable = product.variants.nodes.find((v) => v.availableForSale) || product.variants.nodes[0];
  const selected = Object.fromEntries(firstAvailable.selectedOptions.map((o) => [o.name, o.value]));
  const currentVariant = () => product.variants.nodes.find((v) => v.selectedOptions.every((o) => selected[o.name] === o.value));

  // Gallery (grid on desktop, swipe on phones)
  gallery.innerHTML = product.images.nodes
    .map((im, i) => `<img src="${img(im.url, 1200)}" alt="${esc(im.altText || product.title)}" ${i > 1 ? 'loading="lazy"' : ""}>`).join("");
  dots.innerHTML = product.images.nodes.map((_, i) => `<span class="${i ? "" : "active"}"></span>`).join("");
  gallery.addEventListener("scroll", () => {
    const i = Math.round(gallery.scrollLeft / gallery.clientWidth);
    [...dots.children].forEach((d, j) => d.classList.toggle("active", i === j));
  }, { passive: true });

  // Photo viewer: click a photo to open it full screen, click (or tap) it again to zoom in
  const photos = product.images.nodes;
  const viewer = document.createElement("div");
  viewer.className = "lightbox";
  viewer.hidden = true;
  viewer.setAttribute("role", "dialog");
  viewer.setAttribute("aria-modal", "true");
  viewer.setAttribute("aria-label", "Product photos");
  viewer.innerHTML = `
    <button class="lb-close" data-lb-close aria-label="Close">${ICONS.close}</button>
    ${photos.length > 1 ? `<button class="lb-nav lb-prev" data-lb-step="-1" aria-label="Previous photo">${ICONS.left}</button>
    <button class="lb-nav lb-next" data-lb-step="1" aria-label="Next photo">${ICONS.right}</button>` : ""}
    <div class="lb-stage"><img class="lb-img" alt="" draggable="false"></div>
    ${photos.length > 1 ? `<div class="lb-count"></div>` : ""}`;
  document.body.appendChild(viewer);
  const lbStage = viewer.querySelector(".lb-stage");
  const lbImg = viewer.querySelector(".lb-img");
  const lbCount = viewer.querySelector(".lb-count");
  let lbIndex = 0;
  let lastFocus = null;

  function panTo(x, y) {
    const r = lbStage.getBoundingClientRect();
    const px = Math.min(100, Math.max(0, ((x - r.left) / r.width) * 100));
    const py = Math.min(100, Math.max(0, ((y - r.top) / r.height) * 100));
    lbImg.style.transformOrigin = `${px}% ${py}%`;
  }
  function setZoom(on, x, y) {
    viewer.classList.toggle("zoomed", on);
    if (on && x != null) panTo(x, y); else lbImg.style.transformOrigin = "50% 50%";
  }
  function showPhoto(i) {
    lbIndex = (i + photos.length) % photos.length;
    const im = photos[lbIndex];
    setZoom(false);
    lbImg.src = img(im.url, 2400);
    lbImg.alt = im.altText || product.title;
    if (lbCount) lbCount.textContent = `${lbIndex + 1} / ${photos.length}`;
  }
  function openViewer(i) {
    if (!photos.length) return;
    lastFocus = document.activeElement;
    showPhoto(i);
    viewer.hidden = false;
    document.body.classList.add("no-scroll");
    viewer.querySelector(".lb-close").focus();
  }
  function closeViewer() {
    viewer.hidden = true;
    setZoom(false);
    document.body.classList.remove("no-scroll");
    if (lastFocus) lastFocus.focus();
  }

  gallery.addEventListener("click", (e) => {
    const im = e.target.closest("img");
    if (im) openViewer([...gallery.querySelectorAll("img")].indexOf(im));
  });
  viewer.addEventListener("click", (e) => {
    if (e.target.closest("[data-lb-close]")) { closeViewer(); return; }
    const step = e.target.closest("[data-lb-step]");
    if (step) { showPhoto(lbIndex + Number(step.dataset.lbStep)); return; }
    if (e.target === lbImg && !swiped) setZoom(!viewer.classList.contains("zoomed"), e.clientX, e.clientY);
  });
  lbStage.addEventListener("mousemove", (e) => { if (viewer.classList.contains("zoomed")) panTo(e.clientX, e.clientY); });
  document.addEventListener("keydown", (e) => {
    if (viewer.hidden) return;
    if (e.key === "Escape") closeViewer();
    else if (e.key === "ArrowLeft" && photos.length > 1) showPhoto(lbIndex - 1);
    else if (e.key === "ArrowRight" && photos.length > 1) showPhoto(lbIndex + 1);
  });
  // Phones: swipe to change photo; when zoomed, drag a finger to look around
  let touchX = null, touchY = null, swiped = false;
  lbStage.addEventListener("touchstart", (e) => {
    if (e.touches.length !== 1) return;
    touchX = e.touches[0].clientX; touchY = e.touches[0].clientY; swiped = false;
  }, { passive: true });
  lbStage.addEventListener("touchmove", (e) => {
    if (e.touches.length !== 1) return;
    if (viewer.classList.contains("zoomed")) { e.preventDefault(); panTo(e.touches[0].clientX, e.touches[0].clientY); }
  }, { passive: false });
  lbStage.addEventListener("touchend", (e) => {
    if (touchX == null || viewer.classList.contains("zoomed") || photos.length < 2) { touchX = null; return; }
    const dx = e.changedTouches[0].clientX - touchX;
    const dy = e.changedTouches[0].clientY - touchY;
    if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) { swiped = true; showPhoto(lbIndex + (dx < 0 ? 1 : -1)); setTimeout(() => (swiped = false), 400); }
    touchX = null;
  });

  // Made to order popup (sold-out pieces): pay now or ask on WhatsApp
  const mto = S.madeToOrder || {};
  const waNumber = String(mto.whatsapp || "").replace(/\D/g, "");
  const modal = document.createElement("div");
  modal.className = "mto-modal";
  modal.hidden = true;
  modal.setAttribute("role", "dialog");
  modal.setAttribute("aria-modal", "true");
  modal.setAttribute("aria-labelledby", "mto-title");
  document.body.appendChild(modal);

  function openMto() {
    const v = currentVariant();
    if (!v) return;
    const canPay = v.availableForSale; // needs "Sell when out of stock" on in Shopify
    const name = product.title + (hasOptions ? ` (${v.title})` : "");
    const msg = String(mto.message || "").replace("{product}", name).replace("{url}", location.origin + location.pathname);
    const wa = waNumber
      ? `<a class="btn ghost block" href="https://wa.me/${waNumber}?text=${encodeURIComponent(msg)}" target="_blank" rel="noopener">WhatsApp</a>`
      : `<button class="btn ghost block" data-mto-wa>WhatsApp</button>`;
    modal.innerHTML = `
      <div class="mto-backdrop" data-mto-close></div>
      <div class="mto-box">
        <button class="mto-x" data-mto-close aria-label="Close">${ICONS.close}</button>
        <p class="mto-eyebrow">Made to order</p>
        <h2 class="mto-title" id="mto-title">${esc(name)}</h2>
        <p class="muted">This piece is currently sold out. We can make it for you${mto.leadTime ? ` — ${esc(mto.leadTime)}` : ""}.</p>
        <div class="mto-actions">
          <button class="btn block" data-mto-pay ${canPay ? "" : "disabled"}>Pay now &middot; ${money(v.price)}</button>
          ${wa}
        </div>
      </div>`;
    modal.hidden = false;
    document.body.classList.add("no-scroll");
    const first = modal.querySelector(".mto-actions .btn:not([disabled])");
    if (first) first.focus();
  }
  function closeMto() {
    modal.hidden = true;
    document.body.classList.remove("no-scroll");
  }
  modal.addEventListener("click", async (e) => {
    if (e.target.closest("[data-mto-close]")) { closeMto(); return; }
    if (e.target.closest("[data-mto-wa]")) { toast("WhatsApp ordering is coming soon"); return; }
    const pay = e.target.closest("[data-mto-pay]");
    if (!pay) return;
    pay.disabled = true; pay.textContent = "Redirecting…";
    try {
      // A separate one-item checkout, so the regular cart is left untouched
      const lines = [{ merchandiseId: currentVariant().id, quantity: 1, attributes: [{ key: "Made to order", value: "Yes" }] }];
      const d = (await shopify(`mutation($lines:[CartLineInput!]!) { cartCreate(input:{ lines:$lines }) { cart { checkoutUrl } userErrors { message } } }`, { lines })).cartCreate;
      if (d.userErrors.length) throw new Error(d.userErrors[0].message);
      location.href = d.cart.checkoutUrl;
    } catch (err) {
      console.error(err);
      toast("Sorry, this could not be ordered");
      closeMto();
    }
  });
  document.addEventListener("keydown", (e) => { if (e.key === "Escape" && !modal.hidden) closeMto(); });

  function render() {
    const v = currentVariant();
    const available = v && v.availableForSale && !v.currentlyNotInStock;
    info.innerHTML = `
      <div class="pdp-info-inner">
        <div class="crumbs"><a href="/collections/all">Shop</a><span>/</span><a href="${shopUrl(product.productType)}">${esc(cat ? cat.label : product.productType)}</a></div>
        <div class="pdp-head">
          <div>
            <h1 class="pdp-title">${esc(product.title)}</h1>
            <p class="pdp-price">${money(v ? v.price : product.priceRange.minVariantPrice)}</p>
          </div>
          <button class="pdp-fav" data-fav="${esc(product.handle)}" aria-pressed="${isFav(product.handle)}" aria-label="Save to favorites">${ICONS.fav}</button>
        </div>
        ${hasOptions ? product.options.map((o) => `
          <div class="option-group">
            <span class="option-label">${esc(o.name)}: ${esc(selected[o.name] || "")}</span>
            <div class="option-values">${o.values.map((val) => `<button data-opt="${esc(o.name)}" data-val="${esc(val)}" aria-pressed="${selected[o.name] === val}">${esc(val)}</button>`).join("")}</div>
          </div>`).join("") : ""}
        ${available ? `<button class="btn block pdp-add" data-add>Add to cart</button>` : `<button class="btn block pdp-add" disabled>Sold out</button><button class="btn ghost block pdp-mto" data-mto>Made to order</button>${mto.note ? `<p class="pdp-mto-note">${esc(mto.note)}</p>` : ""}`}
        <div class="accordion">
          <details><summary>Product details</summary><div class="acc-body">${story}</div></details>
          ${details ? `<details><summary>Materials</summary><div class="acc-body">${details}</div></details>` : ""}
          <details><summary>Care</summary><div class="acc-body"><p>${esc(S.care)}</p></div></details>
          <details><summary>Shipping &amp; returns</summary><div class="acc-body"><p>${esc(S.shipping)}</p></div></details>
        </div>
      </div>`;
  }

  info.addEventListener("click", async (e) => {
    const opt = e.target.closest("[data-opt]");
    if (opt) { selected[opt.dataset.opt] = opt.dataset.val; render(); return; }
    if (e.target.closest("[data-mto]")) { openMto(); return; }
    const add = e.target.closest("[data-add]");
    if (add) {
      const v = currentVariant();
      if (!v) return;
      add.disabled = true; add.textContent = "Adding…";
      try { await addToCart(v.id, 1); } catch (err) { console.error(err); toast("Sorry, this could not be added"); }
      render();
    }
  });
  render();

  // Related carousel — same category first
  try {
    const all = await allProducts;
    const related = all.filter((p) => p.handle !== product.handle)
      .sort((a, b) => (b.productType === product.productType) - (a.productType === product.productType))
      .slice(0, 10);
    if (related.length) {
      const sec = document.querySelector("[data-related]");
      sec.querySelector('[data-car="prev"]').innerHTML = ICONS.left;
      sec.querySelector('[data-car="next"]').innerHTML = ICONS.right;
      sec.querySelector(".carousel-track").innerHTML = related.map((p) => productCard(p)).join("");
      sec.hidden = false;
      initCarousels(sec);
    }
  } catch (e) { /* not essential */ }
})();
